<template>
    <div class="modal fade history-filter-modal forgetwithdrawModal-cl" id="newUserWithDrawPasswordModel" tabindex="-1" aria-labelledby="exampleModalLabel"
        data-bs-backdrop="static" data-bs-keyboard="false" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-header">
                    <div class="thm-heading">
                        <p class="para-three">{{$t('forgot-withdraw-password','Forgot Withdraw Password')}}</p>
                    </div>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" @click="resetWithdrawForm()"></button>
                </div>
                <div class="modal-body">
                    <form class="withdraw_password_content">
                        <div class="otp-msg-show">
                            <label for="">{{ $t('otp-sent-to', 'OTP sent to') }} <strong>****** {{ otpSentTo }}</strong></label>
                        </div>
                        <div class="instructions_cl">
                            <p class="para-five instructions_heading">
                                <strong>{{$t('instructions','Instructions')}}</strong>
                            </p>
                            <div class="instructions_ul_div">
                                <ul class="instructions_ul">
                                    <li>
                                        <p>{{$t('withdraw-password-eight-twenty','Withdraw Password must be of minimum 8 characters and maximum 20 characters required')}}</p>
                                    </li>
                                    <li>
                                        <p>{{$t('withdraw-password-small-capital','Withdraw Password must have atleast 1 small and 1 capital alphabet')}}</p>
                                    </li>
                                    <li>
                                        <p>{{$t('withdraw-password-digit-special-char','Withdraw Password must have atleast 1 digit and 1 special character')}}</p>
                                    </li>
                                    <li>
                                        <p class="blue_cl">{{$t('please-take-note-your-withdraw-password','Please Take A Note Of Your Withdraw Password')}}</p>
                                    </li>
                                </ul>
                            </div>
                        </div>

                        <div class="withdraw-input-content cmn_withdraw_cl">
                            <label for="" class="form-label"> {{$t('otp','OTP')}} <span>*</span></label>
                            <div class=" position-relative">
                                <input v-model="withdraw.passwordOtp" type="tel" class="enter-amount-box" maxlength="6" :placeholder="$t('enter-otp','Enter OTP')+''"
                                :class="isOtpApiCalled && init.otp && checkValidation?.otp?.length > 0 ? 'error-input': ''"  @input="withdraw.passwordOtp = $helper.sanitizeNumber(withdraw.passwordOtp, 999999); validate()">
                                <div class="withdraw-otp-row">
                                    <div class="otp-resend resend_otp_btn_sec"> 
                                        <span v-if="minutes > 0 || seconds > 0">{{ minutes }}:{{ seconds }}</span> 
                                        <button type="button" class="resend_otp_btn123" v-if="isResentOtpBtnVisiable" :disabled="loading" :class="{ 'btn-loading': loading }" @click="resendOtp()">
                                            <template v-if="!loading">
                                                {{ $t('resend-otp', 'Resend OTP') }}
                                            </template>
                                            <span v-else>
                                                <b></b><b></b><b></b>
                                            </span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <section v-if="isOtpApiCalled && init.otp && checkValidation?.otp?.length > 0">
                                <section v-for="(err, index) in checkValidation?.otp" :key="index">
                                    <p class="validation-message">{{ $t(err.lang, err.error) }}</p>
                                </section>
                            </section>
                        </div>
                        <div class="withdraw-input-content cmn_withdraw_cl">
                            <label for="" class="form-label">{{$t('withDraw-password','Withdraw Password')}} <span>*</span></label>
                            <div class="password-field-rel position-relative">
                                <input v-model="withdraw.password" :type="oldPasswordFieldType" :placeholder="$t('enter-withdraw-password', 'Enter Withdraw Password')+''" @input="withdraw.password = $helper.sanitizeDetails('withdrawPassword', withdraw.password, 20); validate()" class="enter-amount-box" 
                                :class="isOtpApiCalled && init.password && checkValidation?.withdrawPassword?.length > 0 ? 'error-input' : ''" >
                                <div class="showHide-icon togglePassword" @click="togglePasswordVisibility('oldPassword')">
                                    <i v-if="oldPasswordFieldType === 'password'" aria-hidden="true" class="fa fa-eye-slash"></i>
                                    <i v-else aria-hidden="true" class="fa fa-eye"></i>
                                </div>
                            </div>
                            <!-- <span class="text-danger mt-2 error-messages-text" v-if="withdrawPasswordError">{{ withdrawPasswordError }}</span> -->
                            <section v-if="isOtpApiCalled && init.password && checkValidation?.withdrawPassword?.length > 0">
                                <section v-for="(err, index) in checkValidation?.withdrawPassword" :key="index">
                                    <p class="validation-message">{{ $t(err.lang, err.error) }}</p>
                                </section>
                            </section>
                        </div>
                        <div class="withdraw-input-content cmn_withdraw_cl">
                            <label for="" class="form-label">{{$t('confirm-withdraw-password','Confirm Withdraw Password ')}}<span>*</span></label>
                            <div class="password-field-rel position-relative">
                                <input v-model="withdraw.confirmPassword" :type="newPasswordFieldType" :placeholder="$t('enter-confirm-withdraw-password', 'Enter Confirm Withdraw Password')+''" class="enter-amount-box"
                                @input="withdraw.confirmPassword = $helper.sanitizeDetails('withdrawPassword', withdraw.confirmPassword, 20); validate()" :class="isOtpApiCalled && init.confirmPassword && checkValidation?.confirmWithdrawPassword?.length > 0 ? 'error-input' : ''">
                                <div class="showHide-icon togglePassword" @click="togglePasswordVisibility('newPassword')">
                                    <i v-if="newPasswordFieldType === 'password'" aria-hidden="true" class="fa fa-eye-slash"></i>
                                    <i v-else aria-hidden="true" class="fa fa-eye"></i>
                                </div>
                            </div>
                            <section v-if="isOtpApiCalled && init.confirmPassword && checkValidation?.confirmWithdrawPassword?.length > 0">
                               <section v-for="(err, index) in checkValidation?.confirmWithdrawPassword" :key="index">
                                   <p class="validation-message">{{ $t(err.lang, err.error) }}</p>
                               </section>
                           </section>
                        </div>
                        <button @click="validateOtp()" type="button" class="btn_submit_cl thm-but">{{$t('submit','Submit')}}</button>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import validate from '@/modules/authorization/services/authValidation';
import {resetWithdrawalPassword, openWithdrawPasswordModal, startWithdrawTimer, createComputedForWithdrawPasswordModal} from "@template/utils"
export default {
    name: 'ForgotWithdrawPassword',
    props:{
        triggerAddAccountMethod: Function
    },
    emits:['selectTab'],
    data(){
        return{
            withdraw:{
                passwordOtp: null,
                password: null,
                confirmPassword: null,
                phone: null
            },
            // withdrawPasswordError: null,
            startTime: null,
            endTime: null,
            timeLeft: 0,
            timer: null,
            isResentOtpBtnVisiable : false,
            validationErrors : null,
            init:{
                otp:false,
                confirmPassword:false,
                password:false
            },
            isOtpApiCalled:false,
            oldPasswordFieldType : 'password',
            newPasswordFieldType: 'password',
            loading: false
        }
    },
    computed:{
         minutes() {
            return Math.floor(this.timeLeft / 60).toString().padStart(2, '0');
        },
        seconds() {
            return (this.timeLeft % 60).toString().padStart(2, '0');
        },
        checkValidation() {
			return this.validationErrors;
		}
    },
    beforeCreate(){
        const { otpSentTo } = createComputedForWithdrawPasswordModal()
        this.$helper.applySharedComputed(this, { otpSentTo })
    },
    methods:{
        async validateOtp() {
            this.toggleInit(true);
            if (Object.keys(this.validate())?.filter(key => !['newPassword', 'newUserId'].includes(key))?.length !== 0) return;
            const resetResponse = await this.resetWithdrawalPassword()
            if (resetResponse.error) {
                this.$errorToast(resetResponse?.error);
                if(resetResponse?.error?.[0]?.includes('OTP Expired')){
                    this.isResentOtpBtnVisiable = true;
                    clearInterval(this.timer);
                    this.timeLeft = 0;
                }
                return;
            }
            else {
                await this.resetWithdrawForm();
                this.$helper.closeModal('newUserWithDrawPasswordModel');
                this.resetTimer();
            }
        },
        async resetWithdrawalPassword(){
            if (!this.withdraw.password || this.withdraw.password == null) {
                this.$errorToast("New WithDraw Password Required!");
                return; 
            }
            if (this.withdraw.password != this.withdraw.confirmPassword) {
                this.$errorToast("Confirm WithDraw Password Does Not Match With New WithDraw Password");
                return;
            }
            let data = {
                otp: this.withdraw.passwordOtp,
                password: this.withdraw.password,
            }

            let response = await resetWithdrawalPassword(data)
            if(response?.error) return {error : response.error}
            else return true
        },
        async resendOtp(){
            if (this.loading) return;
            this.loading = true
            try {
                let response = await openWithdrawPasswordModal()
                this.loading = false
                if(!response?.error){
                    this.resetTimer()
                }
            } catch (error) {
                this.loading = false
                this.$errorToast(error);
            }
        },
        async startTimer() {
            startWithdrawTimer((data) => {
                this.isResentOtpBtnVisiable = data.isResentOtpBtnVisiable;
                this.timeLeft = data.timeLeft;
                this.timer = data.timer;
            });
        },
        resetTimer() {
            this.isResentOtpBtnVisiable = false;
            clearInterval(this.timer);
            this.timeLeft = 5 * 60;
            this.startTimer();
        },
        togglePasswordVisibility(fieldName) {
            if(fieldName == 'oldPassword'){
                this.oldPasswordFieldType = this.oldPasswordFieldType === 'password' ? 'text' : 'password';
            } else{
                this.newPasswordFieldType = this.newPasswordFieldType === 'password' ? 'text' : 'password';
            }
        },
        toggleInit(bool){
            this.init={
                otp:bool,
                confirmPassword:bool,
                password:bool
            }
        },
        validate(){
            this.validationErrors = validate.areFieldsValid(
                'withdraw-password',
				this.withdraw.passwordOtp, 
				this.withdraw.password,
				this.withdraw.confirmPassword,
            );
            return this.validationErrors;                                                                                                    
        },
        async resetWithdrawForm(){
            this.withdraw ={
                phone: '',
                passwordOtp: '',
                password: '',
                confirmPassword: ''
            },
            this.isOtpApiCalled = false;
            this.validationErrors = null;
            this.oldPasswordFieldType = 'password',
            this.newPasswordFieldType = 'password',
            this.toggleInit(false)
        },
        otpHasBeenCalled(){
            this.isOtpApiCalled = true;
        }
    }
}
</script>